module.exports = __webpack_public_path__ + "img/icon-camera.9173f300.svg";